import React from 'react';
import styled from 'styled-components';

export const FdpDetails = ({ content = null }) => {
  // free delivery pack

  if (!content) return null;

  return (
    <FdpDetails.Wrapper>
      <FdpDetails.List>
        <p className='mr10'>Eligible to Buy</p>
        <p className='semiBold'>{content.is_eligible_to_buy && 'Yes'}</p>
      </FdpDetails.List>
      <FdpDetails.List>
        <p className='mr10'>FDP User</p>
        <p className='semiBold'>{content.is_fdp_user && 'Yes'}</p>
      </FdpDetails.List>
      <FdpDetails.List>
        <p className='mr10'>Date of Purchase</p>
        <p className='semiBold'>{content.date_of_purchase}</p>
      </FdpDetails.List>
      <FdpDetails.List>
        <p className='mr10'>Price of Purchase</p>
        <p className='semiBold'>{content.price_of_purchase}</p>
      </FdpDetails.List>
    </FdpDetails.Wrapper>
  );
};

FdpDetails.Wrapper = styled.div``;

FdpDetails.List = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;
`;
